module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    ref: "newUserButton",
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-fill",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showModal()
      }
    }
  }, [_vm._v("+ Add New User")])]), _vm._v(" "), _c('user-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModalVisible),
      expression: "isModalVisible"
    }],
    on: {
      "close": _vm.closeModal
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "page-header"
  }, [_vm._v("Account Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('edit-profile-form')], 1)]), _vm._v(" "), (_vm.profiles.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 error_height"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Filter:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "placeholder": "Start Typing"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.support) ? _c('h3', {
    staticClass: "page-header"
  }, [_vm._v("Manage Users")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.profilesSearch), function(item, key, index) {
    return void 0
  }), _vm._v(" "), _vm._l((_vm.profilesSearch), function(item, key, index) {
    return (_vm.current != item.email) ? _c('div', {
      staticClass: "card card-user"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(item.fname + ' ' + item.lname))]), _vm._v(" "), (item.role == 14) ? _c('span', {
      staticClass: "role"
    }, [_vm._v("Corporate")]) : _vm._e(), _vm._v(" "), (item.role == 15) ? _c('span', {
      staticClass: "role"
    }, [_vm._v("Regional")]) : _vm._e(), _vm._v(" "), (item.role == 16) ? _c('span', {
      staticClass: "role"
    }, [_vm._v("Single")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 user-email"
    }, [_vm._v("\n          " + _vm._s(item.email) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 user-phone"
    }, [_vm._v("\n          " + _vm._s(item.phone) + "\n        ")]), _vm._v(" "), (_vm.support || _vm.corp) ? _c('span', {
      staticClass: "col-md-1 pull-right"
    }, [_c('button', {
      staticClass: "btn btn-primary edit-user",
      on: {
        "click": function($event) {
          _vm.deleteUser(item.uid, item.fname, item.lname)
        }
      }
    }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "col-md-2 pull-right"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-wd edit-user",
      attrs: {
        "id": "show-modal"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showModal(item.email)
        }
      }
    }, [_vm._v("Edit")])])])])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fb25887!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/UserProfile.vue
// module id = 366
// module chunks = 1